import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup, Nav, Tab } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ImportIcon from "../../../assets/icons/import-01.svg2";
import MyIcon from "../MyIcon";
import ImportSideIcon from "../../../assets/icons/Icon_Library/application icons/api/import_side.svg2";
import MappingIcon from "../../../assets/icons/Icon_Library/application icons/api/data_mapping.svg2";
import CompleteIcon from "../../../assets/icons/Icon_Library/application icons/general/tick_circled.svg2";
import Mapping from "./Mapping";
import Import from "./Import";
import DetailsIcon from "../../../assets/icons/template_helper.svg2";
import TypeIcon from "../../../assets//icons/Icon_Library/application icons/api/icon_type_choose.svg2";
import BusinessIcon from "../../../assets/icons/Icon_Library/application icons/api/icon_business_hours.svg2";
import AdvancedIcon from "../../../assets/icons/Icon_Library/application icons/api/icon_advanced_settings.svg2";
import ProjectIcon from "../../../assets/icons/Icon_Library/application icons/api/icon_projects.svg2";
import DataIcon from "../../../assets/icons/Icon_Library/application icons/api/icon_data.svg2";
import LogIcon from "../../../assets/icons/Icon_Library/application icons/api/icon_log_files.svg2";
import VerifyingIcon from "../../../assets/icons/Icon_Library/application icons/api/icon_verify.svg2";
import TestIcon from "../../../assets/icons/Icon_Library/application icons/api/icon_testing.svg2";
import ApiIcon from "../../../assets/icons/Icon_Library/application icons/dashboard/create_api_connection.svg2";
import OverviewIcon from "../../../assets/icons/overview-01.svg2";
import Details from "./Details";
import Verifying from "./Verifying";
import Complete from "./Complete";
import ApiType, { apiTypes } from "./ApiType";
import JsonCollapse from "../../Builder/Components/JsonCollapse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faSave, faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  useLazyGetApiConnectionQuery,
  useUpdateApiConnectionMutation,
} from "../../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import NylasStatus from "./NylasStatus";
import ApiModalProjects from "./ApiModalProjects";
import ApiTest from "./ApiTest";
import ApiLogs from "./ApiLogs";
import APIDataCollections from "../../Library/APIDataCollections";
import ApiConnectionAdvanced from "./ApiConnectionAdvanced";
import timezones from "../../Builder/nodes/Logic/timezones";
import { pageProps } from "../../helpers/pageProps";
import FullScreenLoadingIndicator from "../FullScreenLoadingIndicator";
import HelpButton from "../../HelpContent/HelpButton";
import Logs from "../../Dashboard/Logs";
import Input from "../../Builder/nodes/Logic/Inputs/Input";

const tabs = [
  {
    name: "api-type",
    heading: "Type",
    subheading: "Select the API connection type.",
    icon: TypeIcon,
    showFor: [
      "logic",
      "nylas",
      "nylas-contacts",
      "third-party",
      "messaging",
      "ldap",
    ],
    required: true,
    helpId: "api-type-api-connection",
  },
  {
    name: "details",
    heading: "API Overview",
    subheading: "Define the attributes of this API Connection",
    icon: OverviewIcon,
    showFor: [
      "logic",
      "nylas",
      "nylas-contacts",
      "third-party",
      "messaging",
      "ldap",
    ],
    required: true,
    helpId: "api-overview-api-connection",
  },
  ...(pageProps.addOns.social_hours
    ? [
        {
          name: "business-hours",
          heading: "Business Hours",
          subheading: "Specify the business hours for the API connection.",
          icon: BusinessIcon,
          showFor: ["messaging"],
          required: false,
          helpId: "business-hours-api-connection",
        },
      ]
    : []),
  {
    name: "advanced",
    heading: "Advanced",
    subheading: "Define any Query or Post Form Parameters required.",
    icon: AdvancedIcon,
    showFor: ["third-party"],
    required: false,
    helpId: "advanced-settings-api-connection",
  },
  {
    name: "projects",
    heading: "Projects",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: ProjectIcon,
    showFor: ["logic"],
    required: true,
    helpId: "projects-api-connection",
  },

  {
    name: "import",
    heading: "Import",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: ImportSideIcon,
    showFor: [],
    required: false,
    helpId: "import-api-connection",
  },
  {
    name: "mapping",
    heading: "Mapping",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: MappingIcon,
    showFor: [],
    required: false,
    helpId: "mapping-api-connection",
  },
  {
    name: "verifying",
    heading: "Verifying",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: VerifyingIcon,
    showFor: [],
    required: false,
    helpId: "verifying-api-connection",
  },
  {
    name: "test",
    heading: "Test",
    subheading:
      "Save the API as draft to capture incoming request without starting the project.",
    icon: TestIcon,
    showFor: ["logic"],
    required: false,
    helpId: "test-api-connection",
  },
  {
    name: "data",
    heading: "Data",
    subheading: "Convert JSON data into a structured format",
    icon: DataIcon,
    showFor: ["third-party"],
    required: false,
    helpId: "data-api-connection",
  },
  {
    name: "logs",
    heading: "Logs",
    subheading:
      "A record of key events and updates associated to this API Connection.",
    icon: LogIcon,
    showFor: ["logic", "nylas", "third-party", "messaging"],
    required: false,
    helpId: "logs-api-connection",
  },
  {
    name: "complete",
    heading: "Complete",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: CompleteIcon,
    showFor: [],
    required: false,
    helpId: "complete-api-connection",
  },
];

const getTabByErrorKey = (errorKey) => {
  switch (errorKey) {
    case "ApiConnection.Label":
    case "ApiConnection.Description":
    case "ApiConnection.Reference":
      return "details";
    case "ApiConnection.Triggers":
      return "projects";
    default:
      return null;
  }
};

function BusinessHoursForm({ businessHours, setBusinessHours }) {
  return (
    <div className="row">
      <div className="col-12 col-lg-4">
        <div className="bg-purple-gradient-darker-reverse rounded-3 p-3">
          <h5 className="mb-2 fw-bold">Business Hours </h5>
          <p className="mb-2">
            Business Hours control when your communications are processed,
            ensuring messages are sent at the most effective times. Select a day
            to configure its business hours, then set the desired start and end
            times. Any messages received outside these hours will be queued and
            processed during the next available business window.
          </p>
          <p className="mb-2">
            For example, if Business Hours are set from{" "}
            <span className="fw-bold">8:00 AM – 8:00 PM</span>, a message
            received at<span className="fw-bold"> 9:00 PM</span> will be
            processed at<span className="fw-bold"> 8:00 AM</span> the following
            day. If your business is closed on a particular day, mark it as a{" "}
            <span className="fw-bold">Day Off</span> to prevent messages from
            being sent on that day. When no Business Hours are configured,
            communications will be processed at any time without restriction.
          </p>
          <p className="mb-0">
            <ul>
              <span className="fw-bold">Note:</span>
              <li>
                Default Business Hours can be overridden via the{" "}
                <span className="fw-bold">social_hours</span> parameters in the
                relevant API functions.{" "}
              </li>
              <li>
                Setting the <span className="fw-bold">priority</span> parameter
                to <span className="fw-bold">true</span> in an API request will
                also override any Business Hours configuration.
              </li>
            </ul>
          </p>
        </div>
      </div>
      <div className="col-12 col-lg-8">
        <div className="bg-purple-gradient-darker-reverse rounded-3 p-3">
          {[
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday",
          ].map((day, index) => (
            <div key={day} className="row mb-1 align-items-center">
              <div className="col-2">
                <Form.Check
                  id={`${day}-use-restrictions`}
                  type="checkbox"
                  label={day[0].toUpperCase() + day.slice(1)}
                  checked={
                    businessHours?.[day]?.end || businessHours?.[day]?.start
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setBusinessHours({
                        ...(businessHours || {}),
                        [day]: {
                          ...(businessHours?.[day] || {}),
                          start: 9,
                          end: 17,
                          day_off: false,
                        },
                      });
                    } else {
                      setBusinessHours({
                        ...(businessHours || {}),
                        [day]: {
                          ...(businessHours?.[day] || {}),
                          day_off: false,
                          start: 0,
                          end: 0,
                        },
                      });
                    }
                  }}
                />
              </div>
              {!businessHours?.[day]?.end && !businessHours?.[day]?.start ? (
                <div className="col-8">
                  <div className="p-2 m-0 alert alert-success">
                    Sending all day - no restrictions
                  </div>
                </div>
              ) : (
                <>
                  {businessHours?.[day]?.day_off ? (
                    <div className="col-8">
                      <div className="p-2 m-0 alert alert-warning">
                        No business on this day
                      </div>
                    </div>
                  ) : (
                    ["start", "end"].map((time) => (
                      <div className="col-4" key={`${day}-${time}`}>
                        <select
                          className="form-select"
                          disabled={businessHours?.[day]?.day_off}
                          value={businessHours?.[day]?.[time] || 0}
                          onChange={(e) =>
                            setBusinessHours({
                              ...(businessHours || {}),
                              [day]: {
                                ...(businessHours?.[day] || {}),
                                [time]: parseInt(e.target.value),
                              },
                            })
                          }
                        >
                          {Array.from({ length: 25 }, (_, i) => i)
                            .filter((h) => !(time === "end" && h === 0))
                            .filter(
                              (h) =>
                                !(
                                  time === "end" &&
                                  h <= businessHours?.[day]?.start
                                )
                            )
                            .filter(
                              (h) =>
                                !(
                                  time === "start" &&
                                  h >= businessHours?.[day]?.end
                                )
                            )
                            .map((h) => (
                              <option key={h} value={h}>
                                {`${h.toString().padStart(2, "0")}:00`}
                              </option>
                            ))}
                        </select>
                      </div>
                    ))
                  )}
                  <div className="col">
                    <Form.Check
                      id={`${day}-off-day`}
                      type="checkbox"
                      label={"Day off"}
                      checked={businessHours?.[day]?.day_off}
                      onChange={(e) => {
                        setBusinessHours({
                          ...(businessHours || {}),
                          [day]: {
                            ...(businessHours?.[day] || {}),
                            day_off: e.target.checked,
                          },
                        });
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          ))}
          <hr />
          <div className="d-flex">
            <InputGroup.Text>Default time zone</InputGroup.Text>
            <div className="w-100">
              <Input
                inputType="select"
                value={[businessHours?.time_zone]}
                onChange={([v]) => {
                  setBusinessHours({
                    ...(businessHours || {}),
                    time_zone: v,
                  });
                }}
                options={timezones.map((tz) => ({
                  value: tz.tzCode,
                  label: tz.label,
                }))}
              />
            </div>
          </div>
          <div>
            <Form.Check
              className="mt-2"
              id={`use-account-timezone`}
              type="checkbox"
              label={
                <span>
                  Use destination if possible
                  <HelpButton helpKey="business-hours-destination" />
                </span>
              }
              checked={businessHours?.from_destination || false}
              onChange={(e) => {
                setBusinessHours({
                  ...(businessHours || {}),
                  from_destination: e.target.checked,
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const newAPI = {
  Label: "New API Connection",
  Reference: "",
  Description: "",
  Kind: "",
  Status: "draft",
  NylasEmail: "",
};

const logKinds = ["api_connection", "api_request"];

function DataImportModal({
  apiUuid,
  onClose,
  initialTabName = "api-type",
  showButton = undefined,
}) {
  const [show, setShow] = useState(false);
  const [selectedTabName, setSelectedTabName] = useState(initialTabName);
  const navigate = useNavigate();
  const location = useLocation();
  const [api, setApi] = useState({});
  const [getApiConnection] = useLazyGetApiConnectionQuery();
  const [backendErrors, setBackendErrors] = useState();

  useEffect(() => {
    if (!!showButton && !show) {
      return;
    }
    if (apiUuid) {
      if (apiUuid === "add") {
        setApi(newAPI);
        return;
      }
      if (apiUuid !== api.Uuid) {
        getApiConnection(apiUuid).then(({ data }) => {
          if (data) {
            setApi(data);
          } else {
            toast.error("Failed to load API connection!");
            if (!!showButton) {
              setShow(false);
            } else {
              onClose?.();
            }
          }
        });
      }
    }
  }, [apiUuid, show]);

  const selectedTab = tabs.find((t) => t.name === selectedTabName) || tabs[0];

  const availableTabs = tabs
    .filter((t) => t.showFor.includes(api.Kind))
    .filter((t) => t.name !== "logs" || api.Uuid)
    .filter((t) => t.name !== "test" || api.Uuid);

  const currentTabIndex = availableTabs.findIndex(
    (t) => t.name === selectedTabName
  );

  // check which tabs are completed
  const completedTabs = [""]; // business hours is optional
  if (api.Kind) {
    completedTabs.push("api-type");
  }
  if (api.Label && api.Reference) {
    completedTabs.push("details");
  }
  if (api.Triggers && api.Triggers.length > 0) {
    completedTabs.push("projects");
  }

  const [updateApiConnection, { isLoading }] = useUpdateApiConnectionMutation();
  const handleComplete = async () => {
    setBackendErrors(undefined);
    const res = await updateApiConnection(api);
    if (res.error) {
      setBackendErrors(res.error.data?.errors);
      toast.error("Failed to update API connection!");
      setSelectedTabName(
        getTabByErrorKey(Object.keys(res.error.data?.errors)[0])
      );
      return;
    }
    if (res.data) {
      if (!api.Uuid && !showButton) {
        navigate(`/library/api-connections/${res.data.Uuid}/details`);
      }
      setApi(res.data);
      toast.success("API connection updated successfully!");
    }
  };

  const handleClose = () => {
    setApi({});
    setShow(false);
    setSelectedTabName(initialTabName);
    setBackendErrors(undefined);
    onClose?.();
  };

  return (
    <>
      <FullScreenLoadingIndicator loading={isLoading} />
      {showButton && (
        <div
          className="h-100"
          onClick={() => {
            setShow(true);
          }}
        >
          {showButton}
        </div>
      )}
      <Modal
        show={showButton ? show : true}
        onHide={handleClose}
        size="xl"
        contentClassName="bg-purple-gradient"
      >
        <Modal.Header className="bg-colored-reverse p-3 rounded-3" closeButton>
          <Modal.Title className="text-white">
            <ApiIcon width={30} className="text-white ms-2" />
            <span className="ms-3 fw-bold">
              API Connections{" "}
              <HelpButton helpKey="create-api-connection-overview" />{" "}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          <Tab.Container
            id="data-import-tabs"
            activeKey={selectedTabName}
            onSelect={(tab) => {
              setSelectedTabName(tab);
            }}
            mountOnEnter
          >
            <Nav variant="tabs" className="align-items-end flex-nowrap">
              <div className="d-flex align-items-center mb-3">
                <div className="fw-bold">
                  <MyIcon
                    Icon={selectedTab.icon}
                    width={40}
                    className="ms-2 "
                  />
                </div>
                <div className="ms-3">
                  <div className="fs-2 fw-bold">
                    {selectedTab.heading}{" "}
                    {api.Kind && (
                      <small>
                        ({apiTypes.find((a) => a.name === api.Kind).heading})
                      </small>
                    )}
                    {selectedTab.helpId && (
                      <HelpButton helpKey={selectedTab.helpId} />
                    )}
                  </div>
                  <span className="text-secondary">
                    {selectedTab.subheading}
                  </span>
                </div>
              </div>
              <div className="flex-grow-1"></div>
              {availableTabs.map((t, i) => {
                const disabled =
                  i > 0 &&
                  availableTabs
                    .slice(0, i)
                    .some(
                      (at) => at.required && !completedTabs.includes(at.name)
                    );

                return (
                  <Nav.Item
                    style={{ minWidth: 80 }}
                    key={t.name}
                    className={`position-relative ${
                      disabled ? "opacity-50" : ""
                    }`}
                  >
                    {completedTabs.includes(t.name) && t.required && (
                      <div className="position-absolute top-0 end-0 m-2 badge bg-colored text-white rounded-1 p-1 z-1">
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                    )}
                    <Nav.Link
                      eventKey={t.name}
                      className="fw-bold"
                      disabled={disabled}
                    >
                      <div className="d-flex flex-column align-items-center">
                        <div>
                          <t.icon width={30} className="text-purple ms-2" />
                        </div>
                        <div
                          className="text-black fw-bold  mt-2 text-uppercase"
                          style={{ letterSpacing: 2 }}
                        >
                          {t.heading}
                        </div>
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                );
              })}
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="api-type">
                <ApiType
                  api={api}
                  onChange={(Kind) => {
                    setApi((p) => ({
                      ...p,
                      Kind,
                      Messaging:
                        Kind === "messaging"
                          ? {
                              Username: "",
                              Password: "",
                              use_social_hours: false,
                              use_secure_data: false,
                              default_dynamic_header: "",
                              social_hours: {
                                monday: {
                                  day_off: false,
                                  start: 9,
                                  end: 17,
                                },
                                tuesday: {
                                  day_off: false,
                                  start: 9,
                                  end: 17,
                                },
                                wednesday: {
                                  day_off: false,
                                  start: 9,
                                  end: 17,
                                },
                                thursday: {
                                  day_off: false,
                                  start: 9,
                                  end: 17,
                                },
                                friday: {
                                  day_off: false,
                                  start: 9,
                                  end: 17,
                                },
                                saturday: {
                                  day_off: true,
                                  start: 9,
                                  end: 17,
                                },
                                sunday: {
                                  day_off: true,
                                  start: 9,
                                  end: 17,
                                },
                              },
                            }
                          : null,
                      Profile:
                        Kind === "third-party"
                          ? {
                              BaseUrl: "http://api:9090",
                              AuthKind: "",
                              AuthHeader: "Authorization",
                              AuthValue: "Basic <base64encryptedstring>",
                              Timeout: 1,
                              DefaultMethod: "GET",
                              ContentType: "JSON",
                              QueryParams: null,
                              FormData: null,
                              JsonPayload: null,
                              JsonPayloadTokens: null,
                              ComponentConfig: null,
                              JsonApiDataCollections: null,
                            }
                          : null,
                    }));
                  }}
                />
              </Tab.Pane>

              <Tab.Pane eventKey="details">
                <Details
                  backendErrors={backendErrors}
                  api={api}
                  onChange={(values) => {
                    setApi((p) => ({ ...p, ...values }));
                  }}
                />
              </Tab.Pane>

              {api.Messaging && (
                <Tab.Pane eventKey="business-hours">
                  <div className="mb-5 mt-3 m-5">
                    <Form.Check
                      className="my-3 d-flex gap-2 align-items-center"
                      id={`use-business-hours`}
                      type="switch"
                      label={"Use business hours restrictions"}
                      checked={api.Messaging.use_social_hours}
                      onChange={(e) => {
                        setApi((p) => ({
                          ...p,
                          Messaging: {
                            ...(p.Messaging || {}),
                            use_social_hours: e.target.checked,
                          },
                        }));
                      }}
                    />
                    {api.Messaging.use_social_hours && (
                      <BusinessHoursForm
                        businessHours={api.Messaging.social_hours || {}}
                        setBusinessHours={(social_hours) => {
                          console.log(social_hours);
                          setApi((p) => ({
                            ...p,
                            Messaging: {
                              ...(p.Messaging || {}),
                              social_hours,
                            },
                          }));
                        }}
                      />
                    )}
                  </div>
                </Tab.Pane>
              )}

              <Tab.Pane eventKey="advanced">
                {api?.Kind === "third-party" && (
                  <ApiConnectionAdvanced
                    api={api.Profile}
                    onChange={(Profile) => setApi({ ...api, Profile })}
                  />
                )}
              </Tab.Pane>

              <Tab.Pane eventKey="data">
                {api.Uuid ? (
                  <div className="mt-3">
                    <APIDataCollections ApiProfile={api.Profile} />
                  </div>
                ) : (
                  <div className="mt-3 p-5 alert alert-secondary">
                    Please save the API connection to view data collections.
                  </div>
                )}
              </Tab.Pane>

              <Tab.Pane eventKey="projects">
                <ApiModalProjects
                  api={api}
                  onChange={(values) => {
                    setApi((p) => ({ ...p, ...values }));
                  }}
                  backendErrors={backendErrors}
                />
              </Tab.Pane>

              <Tab.Pane eventKey="credentials">Credentials</Tab.Pane>
              <Tab.Pane eventKey="test">
                <ApiTest api={api} />
              </Tab.Pane>
              <Tab.Pane eventKey="logs">
                <Logs resource={api.Uuid} kind={logKinds} />
              </Tab.Pane>

              <Tab.Pane eventKey="import">
                <Import />
              </Tab.Pane>

              <Tab.Pane eventKey="mapping">
                <Mapping />
              </Tab.Pane>

              <Tab.Pane eventKey="verifying">
                <Verifying />
              </Tab.Pane>

              <Tab.Pane eventKey="complete">
                <Complete onComplete={handleComplete} />
              </Tab.Pane>

              <Tab.Pane eventKey="status">
                <NylasStatus
                  CONNECTION_UUID={api.Uuid}
                  NYLAS_EMAIL={api.NylasEmail}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>
        {selectedTabName !== "status" && api.Kind && (
          <div className="d-flex justify-content-between p-3">
            <div>
              {selectedTabName !== "api-type" && (
                <Button
                  type="submit"
                  className="btn btn-colored-reverse rounded-pill fw-bold px-4 "
                  onClick={() => {
                    setSelectedTabName(
                      availableTabs[currentTabIndex - 1]?.name || "api-type"
                    );
                  }}
                >
                  PREVIOUS
                </Button>
              )}
            </div>
            <div>
              {currentTabIndex < availableTabs.length - 1 ? (
                <Button
                  type="submit"
                  className="btn btn-colored-reverse rounded-pill fw-bold px-4 "
                  onClick={() => {
                    setSelectedTabName(
                      availableTabs[currentTabIndex + 1]?.name || "complete"
                    );
                  }}
                  disabled={
                    currentTabIndex === availableTabs.length - 1 ||
                    (currentTabIndex > 0 &&
                      !completedTabs.includes(
                        availableTabs[currentTabIndex].name
                      ) &&
                      availableTabs[currentTabIndex].required)
                  }
                >
                  NEXT
                </Button>
              ) : null}
              {(currentTabIndex === availableTabs.length - 1 ||
                (apiUuid && apiUuid !== "add")) &&
              availableTabs[currentTabIndex].name !== "logs" ? (
                <Button
                  type="submit"
                  className="btn btn-colored-reverse rounded-pill fw-bold px-4 ms-2"
                  onClick={handleComplete}
                  disabled={isLoading}
                >
                  {apiUuid && apiUuid !== "add" ? "UPDATE" : "SAVE"}
                </Button>
              ) : null}
            </div>
          </div>
        )}
        <JsonCollapse json={api} />
      </Modal>
    </>
  );
}

export default DataImportModal;
